import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Markdown from 'marked-react';

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.2,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  description: {
    marginBottom: theme.spacing(3.5),
    textAlign: 'center',
  },
}));

const CustomTitle = ({ title, description }) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h4" className={classes.title}>
        <Markdown isInline>{title}</Markdown>
      </Typography>
      {description && (
        <Typography variant="body1" className={classes.description}>
          <Markdown isInline>{description}</Markdown>
        </Typography>
      )}
    </>
  );
};

CustomTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default CustomTitle;
